// setTimeout(() => {
  $('.product-grid.product-custom-grid').slick({
    mobileFirst: true,
    infinite: true,
    dots: false,
    speed: 1000,
    focusOnSelect: true,
    slidesToShow: 2, // Mobile first, 1 slide on small screens
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: $('.slick-prev'), // Link the custom left button
    nextArrow: $('.slick-next'),
    responsive: [
      {
        breakpoint: 576, // Screens >= 576px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Screens >= 768px
        settings: {
          slidesToShow: 3,
          dots: false
        },
      },
      {
        breakpoint: 992, // Screens >= 992px
        settings: {
          slidesToShow: 4,
          dots: false
        },
      }
    ]
  });
  // document.addEventListener("DOMContentLoaded", () => {
  //   document.querySelector(".product-slider-container").style.visibility = unset;
  // });
// }, 1000);
setTimeout(() => {
  $('.relatedmy').slick({
    mobileFirst: true,
    infinite: false,
    dots: true,
    arrows: false,
    speed: 1000,
    focusOnSelect: true,
    slidesToShow: 2, // Mobile first, 1 slide on small screens
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: '<button class="slider-button slider-button--prev" type="button" data-bs-slide="prev"><span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span><span class="visually-hidden">Previous</span></button>',
    nextArrow: '<button class="slider-button slider-button--next" type="button" data-bs-slide="next"><span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span><span class="visually-hidden">Next</span></button>',
    responsive: [
      {
        breakpoint: 576, // Screens >= 576px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Screens >= 768px
        settings: {
          slidesToShow: 3,
          arrows: true,
          dots: false
        },
      },
      {
        breakpoint: 992, // Screens >= 992px
        settings: {
          slidesToShow: 4,
          arrows: true,
          dots: false
        },
      }
    ]
  });
  const savedCurrency = localStorage.getItem('selectedCurrency');
  if (savedCurrency) {
    updatePrices(savedCurrency);
  }
  document.querySelector(".related-products-container").style.display = 'block';
}, 3000);
